import React, { useEffect } from "react";

import range from "lodash/range";
import ReactTooltip from "react-tooltip";

import VaspCard from "../VaspSections/cards/VaspCard";
import { Container, VaspCardContainer } from "./styles";

import { VASP } from "~/types/vaspid";

interface Props {
  vasps?: VASP[];
  handleVaspCardClicked: (vasp: VASP) => void;
  includeGatewayBelonging: boolean;
  includeVaspReview?: boolean;
}

export default function VaspList({
  vasps,
  handleVaspCardClicked,
  includeGatewayBelonging = false,
  includeVaspReview = false,
}: Props) {
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  //render Skeleton placeholder if vasps are not loaded
  if (!vasps) {
    return (
      <Container>
        {range(0, 20).map((i) => (
          <VaspCardContainer key={i}>
            <VaspCard
              onClick={() => {
                /*nothing*/
              }}
            />
          </VaspCardContainer>
        ))}
      </Container>
    );
  }

  return (
    <Container data-testid="listContainer">
      {vasps.map((vasp) => (
        <VaspCardContainer key={vasp.did}>
          <VaspCard
            vasp={vasp}
            onClick={() => handleVaspCardClicked(vasp)}
            includeGatewayBelonging={includeGatewayBelonging}
            includeVaspReview={includeVaspReview}
          />
        </VaspCardContainer>
      ))}
    </Container>
  );
}
